import { SERVER_API } from "../../Constant";
import axios from "axios";

// Fetch Product Offers
export const FetchProductOffers_api = async () => {
  try {
    const response = await axios.get(
      `${SERVER_API}/ProductOffers/fetch_product_offers.php`,
    );
    return response.data;
  } catch (error) {
    console.error("Fetch product offers failed:", error);
    return { error: "Fetch product offers failed" };
  }
};

// Add Product Offer
export const AddProductOffer_api = async (inputs: any) => {
  try {
    const formData = new FormData();
    formData.append("inputs", JSON.stringify(inputs));

    const response = await axios.post(
      `${SERVER_API}/ProductOffers/add_product_offer.php`,
      formData,
    );
    return response.data;
  } catch (error) {
    console.error("Add product offer failed:", error);
    return { error: "Add product offer failed" };
  }
};

// Fetch Inquiry List
export const FetchInquiryList_api = async () => {
  try {
    const response = await axios.get(
      `${SERVER_API}/ProductOffers/fetch_inquiry_list.php`,
    );
    return response.data;
  } catch (error) {
    console.error("Fetch product offer inquiry list failed:", error);
    return { error: "Fetch product offer inquiry list failed" };
  }
};

// Fetch Active Stock
export const FetchActiveStock_api = async () => {
  try {
    const response = await axios.get(
      `${SERVER_API}/ProductOffers/fetch_active_stock.php`,
    );
    return response.data;
  } catch (error) {
    console.error("Fetch product offer active stock failed:", error);
    return { error: "Fetch product offer active stock failed" };
  }
};
